import { render, staticRenderFns } from "./ChannelMessagePreview.vue?vue&type=template&id=d6cc843a&scoped=true"
import script from "./ChannelMessagePreview.vue?vue&type=script&lang=js"
export * from "./ChannelMessagePreview.vue?vue&type=script&lang=js"
import style0 from "./ChannelMessagePreview.vue?vue&type=style&index=0&id=d6cc843a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6cc843a",
  null
  
)

export default component.exports